import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityListRefresh {
  private _refresh = new Subject<string>();

  public refresh$ = this._refresh.asObservable();

  refresh(entityName: string) {
    this._refresh.next(entityName);
  }
}
